module.exports = __webpack_public_path__ + "app/kiss-order/detail/order-header-info-UVt0Z5yn.html";